module.exports = __webpack_public_path__ + "10d5fd6e5729ff6efd9cfa9bf70a047b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/mihai-cirlanaru.jpg
 ** module id = 422
 ** module chunks = 0
 **/